import React, { FunctionComponent } from 'react'
import Svg, { Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { AuroraThemeType } from '../../utils/themes/ThemeProvider'

type Props = {
  size?: number | string
}

export const AuroraMedicationConsultationSecondaryRecIllustration: FunctionComponent<Props> = ({ size = 64 }) => {
  const { colors } = useTheme() as AuroraThemeType
  const { spotIllustration } = colors.icons

  return (
    <Svg width={size} height={size} viewBox='0 0 64 64' fill='none'>
      <Path
        d='M24.1709 13.7571C24.1709 13.7571 36.8903 10.7297 38.1006 10.8736C39.2177 11.0062 40.0125 11.3194 40.9296 14.0237C41.8133 16.6293 47.8562 42.8921 47.8673 42.9542C48.5093 46.5529 46.8891 46.8999 45.3523 47.522C43.8336 48.1385 26.8805 52.1773 22.3674 53.2424C21.1849 53.5217 19.8913 53.5584 18.8937 53.2114C18.1044 52.9363 17.2596 52.7092 16.3565 49.7664C15.2073 46.0253 10.0398 21.0885 10.0398 21.0885C10.0398 21.0885 9.48543 18.0188 12.5131 17.0892C15.5394 16.1595 24.1696 13.7571 24.1696 13.7571H24.1709Z'
        fill={spotIllustration.secondary.fill}
      />
      <Path
        d='M24.7809 16.2145C24.7809 16.2145 35.8051 13.5907 36.8528 13.7148C37.8213 13.8291 38.5091 14.0999 39.3053 16.4459C40.0709 18.7044 45.3078 41.4645 45.3176 41.5181C45.8734 44.6372 44.47 44.9377 43.1389 45.4765C41.823 46.0098 27.1305 49.5111 23.2191 50.4337C22.1951 50.675 21.0738 50.7074 20.2095 50.4069C19.5245 50.1685 18.7936 49.9724 18.0099 47.4205C17.0151 44.1787 12.5353 22.5669 12.5353 22.5669C12.5353 22.5669 12.056 19.9063 14.6779 19.1008C17.3013 18.2953 24.7809 16.2131 24.7809 16.2131V16.2145Z'
        fill={spotIllustration.primary.fill}
      />
      <Path
        d='M20.7847 14.0294C20.7847 14.0294 16.2661 14.7686 16.3328 16.1863C16.3981 17.6027 16.4272 19.7766 18.6768 19.596C20.9264 19.4154 33.2345 16.3189 33.9835 15.5741C34.7338 14.8278 34.1377 11.4238 32.9427 11.2207C31.7478 11.0176 28.3644 12.163 28.3644 12.163C28.3644 12.163 26.904 9.28241 24.0625 10.1697C21.221 11.0571 20.7861 14.0308 20.7861 14.0308L20.7847 14.0294Z'
        fill={spotIllustration.secondary.fill}
      />
      <Path
        d='M50.5605 54H37.3492C36.4461 54 35.7124 53.2565 35.7124 52.3382L35.0913 30.8406L53.0908 31.9438L52.1945 52.3735C52.1751 53.2763 51.4484 53.9986 50.5591 53.9986L50.5605 54Z'
        fill={spotIllustration.secondary.fill}
      />
      <Path
        d='M49.5195 45.993H41.4368C40.4656 45.993 39.6777 45.0478 39.6777 43.8811V37.509C39.6777 36.3424 40.4656 35.3972 41.4368 35.3972H49.9377C50.909 35.3972 51.6968 36.3424 51.6968 37.509L51.28 43.8811C51.28 45.0478 50.4921 45.993 49.5209 45.993H49.5195Z'
        fill={spotIllustration.primary.fill}
      />
      <Path d='M49.9295 37.9322H41.8496V39.1284H49.9295V37.9322Z' fill={spotIllustration.secondary.fill} />
      <Path d='M49.9295 41.1259H41.8496V42.2192H49.9295V41.1259Z' fill={spotIllustration.secondary.fill} />
      <Path
        d='M53.3311 29.2339L34.9523 29.1126C34.6536 29.1112 34.4049 29.3454 34.3854 29.6473L34.202 32.4362C34.1798 32.7663 34.4382 33.047 34.7648 33.047H53.4353C53.7563 33.047 54.012 32.7762 53.9995 32.4503L53.8911 29.7827C53.8786 29.4766 53.6326 29.2353 53.3311 29.2339Z'
        fill={spotIllustration.secondary.fill}
      />
      <Path
        d='M52.0472 27.084L36.5057 26.5154C36.018 26.4971 35.59 26.8117 35.5025 27.2518L34.7925 30.8717H53.3922L52.9795 27.8669C52.9198 27.4324 52.5252 27.1009 52.0472 27.084Z'
        fill={spotIllustration.secondary.fill}
      />
    </Svg>
  )
}
